import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

class UserLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            login: null,
            password: null
        }
    }

    render() {
        return (
            <div className="col-md-5" style={{margin: '0 auto'}}>
                <Form>
                    <h3>Авторизация</h3>
                    <Form.Group>
                        <a href="/auth.php"><Button>Войти через VK</Button></a>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

export default withRouter(UserLogin);


// WEBPACK FOOTER //
// ./src/components/UserLogin.js